import { h } from 'preact'

import MainCalculatorView from './components/main'

const MainCalculatorApp = () => {
  return (
    <div
      id="preact_root"
      className="calc-widget__container testss"
    >
      <MainCalculatorView />
    </div>
  )
}

export default MainCalculatorApp
